import * as React from 'react'
import clsx from 'clsx'
import { styled, css } from '@mui/system'
import { Modal as BaseModal } from '@mui/base/Modal'
import { Clear } from '@mui/icons-material'

type Props = {
  children: any
  open: boolean
  setOpen: any
  title?: string
  titleClasses?: string
  contentClasses?: string
  contentStyle?: React.CSSProperties
  hideClose?: boolean
  hideDivider?: boolean
}

export default function CustomModal(props: Props) {
  const { children, open, setOpen, title, titleClasses, contentClasses, contentStyle, hideClose, hideDivider } = props
  const handleClose = (_?: any, reason?: string) => {
    if (reason !== 'backdropClick') {
      setOpen(false)
    }
  }

  return (
    <div>
      <Modal
        disableEscapeKeyDown
        aria-labelledby="unstyled-modal-title"
        aria-describedby="unstyled-modal-description"
        open={open}
        onClose={handleClose}
        slots={{ backdrop: StyledBackdrop }}
      >
        <ModalContent className={contentClasses} style={contentStyle}>
          {/* Head */}
          <div className={`flex !max-w-[95vw] items-center justify-between pb-3 ${hideDivider ? '' : 'border-b border-[var(--app-border-light)]'}`}>
            <h2 className={`text-lg font-semibold tracking-tight text-[var(--app-text)] ${titleClasses || ''}`}>{title}</h2>
            {hideClose ? null : (
              <Clear
                className="cursor-pointer rounded-lg p-1 text-[var(--app-text-secondary)] opacity-75 transition hover:bg-[var(--app-surface-secondary)] hover:opacity-100"
                fontSize="medium"
                onClick={handleClose}
              />
            )}
          </div>
          {children}
        </ModalContent>
      </Modal>
    </div>
  )
}

const Backdrop = React.forwardRef<HTMLDivElement, { open?: boolean; className: string }>((props, ref) => {
  const { open, className, ...other } = props
  return <div className={clsx({ 'base-Backdrop-open': open }, className)} ref={ref} {...other} />
})

const Modal = styled(BaseModal)`
  position: fixed;
  z-index: 1300;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`

const StyledBackdrop = styled(Backdrop)`
  z-index: -1;
  position: fixed;
  inset: 0;
  background-color: rgb(15 23 42 / 0.38);
  backdrop-filter: blur(2px);
  -webkit-tap-highlight-color: transparent;
`

const ModalContent = styled('div')(
  ({ theme }: any) => css`
    position: relative;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 16px;
    overflow: hidden;
    background-color: ${theme.palette.mode === 'dark' ? '#1C2025' : '#fff'};
    border-radius: 16px;
    border: 1px solid ${theme.palette.mode === 'dark' ? '#2a2f3a' : '#e2e6ee'};
    box-shadow: 0 18px 50px ${theme.palette.mode === 'dark' ? 'rgb(0 0 0 / 0.5)' : 'rgb(17 24 39 / 0.16)'};
    padding: 24px;
    color: ${theme.palette.mode === 'dark' ? '#F3F6F9' : '#1C2025'};
  `,
)
